import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const asyncChangeboardingModalEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "public-forms-changeboarding-modal" */ './PublicFormChangeboardingModal.tsx'
			),
	),
	getPreloadProps: () => ({}),
});
